import { useEffect, useRef } from "preact/hooks";
import { useStoreSync } from "./sync";
import { AreaStore, B2cProduct, FiltersChangeHandler } from "./store";
import { MinimalB2cBrand, MinimalB2cCategory } from "./options";
import { AreaFilters, getHash } from "./area-filters";
import { useServices } from "@/services-context";

export const useProductAreaStore = (params: {
    filters: AreaFilters;
    brands: MinimalB2cCategory[];
    categories: MinimalB2cBrand[];
    products: B2cProduct[];
    more: boolean;
    onFiltersChange: FiltersChangeHandler;
    totalItems: number;
}) => {
    const services = useServices();
    const hash = getHash(params.filters);
    const store = useRef<AreaStore>(null);
    if (!store.current) {
        store.current = new AreaStore(services.breadcrumbs);
        store.current.setParams({
            filters: params.filters,
            brands: params.brands,
            categories: params.categories,
            products: params.products,
            more: params.more,
            onFiltersChange: params.onFiltersChange,
            totalItems: params.totalItems,
        });
    }

    useEffect(() => {
        return () => {
            store.current?.release();
        };
    }, [store.current]);

    useEffect(() => {
        store.current?.setParams({
            filters: params.filters,
            brands: params.brands,
            categories: params.categories,
            products: params.products,
            more: params.more,
            onFiltersChange: params.onFiltersChange,
            totalItems: params.totalItems,
        });
        store.current?.notifyUpdate();
    }, [store.current, hash, params.brands, params.categories, params.products, params.more, params.onFiltersChange]);

    useStoreSync(store.current.sync);

    return store.current;
};